import { isReactive, toRaw } from 'vue';

export function toRawDeep(obj) {
  if (!isReactive(obj)) {
    return obj;
  }

  const result = toRaw(obj);
  // 递归地转换所有可枚举的属性
  Object.keys(result).forEach((key) => {
    const value = result[key];
    if (typeof value === 'object' && value !== null) {
      result[key] = toRawDeep(value); // 递归调用
    }
  });

  return result;
}
